import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { getRouter } from '@/router';

// The single stylesheet entry. Tailwind's Vite plugin compiles it; nothing else imports CSS.
import '@/styles.css';

const container = document.getElementById('root');
if (container === null) {
  // Fail loudly. A silent no-op here renders a blank page with a clean console, which is
  // the single most confusing way for a frontend to break.
  throw new Error('#root is missing from index.html');
}

createRoot(container).render(
  <StrictMode>
    <RouterProvider router={getRouter()} />
  </StrictMode>,
);
